// @flow
import uuid from 'uuid';
import i18n from 'i18n-js';

import * as gatewayActions from '../../../actions/gateways';

export const validate = (values: Object) => {
  const {
    name,
    ordinal,
    gate,
    allow_exit,
    allow_entrance,
  } = values;

  const errors = {};

  if (!name) {
    errors.name = i18n.t('labels.requiredField');
  }

  if (!ordinal) {
    errors.ordinal = i18n.t('labels.requiredField');
  }

  if (!gate || !gate.id) {
    errors.gate = i18n.t('labels.requiredField');
  }

  if (!allow_exit && !allow_entrance) {
    errors.allow_entrance = 'Debe permitir por lo menos una';
  }

  return errors;
};

export const onSubmit = (values: Object, dispatch: Function) => {
  const {
    name,
    ordinal,
    gate,
    allow_exit,
    allow_change_requests,
    allow_entrance,
  } = values;
  dispatch(gatewayActions.gatewayCreateStarted({
    id: uuid(),
    name,
    ordinal,
    gate: gate.id,
    allow_exit,
    allow_change_requests,
    allow_entrance,
  }));
};



// WEBPACK FOOTER //
// ./src/scripts/components/CreateExitMethodPopupContent/CreateExitMethodPopupForm/utils.js